import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4b88c110&scoped=true&"
import script from "./main.vue?vue&type=script&lang=ts&"
export * from "./main.vue?vue&type=script&lang=ts&"
import style0 from "./main.vue?vue&type=style&index=0&id=4b88c110&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b88c110",
  null
  
)

export default component.exports